import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import UserMigration from './pages/UserMigration';

const container = document.getElementById('root');
const root = createRoot(container!);
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
root.render(
	<React.StrictMode>
		<Auth0Provider
			domain={process.env.REACT_APP_AUTH0_DOMAIN!}
			clientId={clientId!}
			cookieDomain={process.env.REACT_APP_COOKIE_DOMAIN}
			cacheLocation="memory"
			sessionCheckExpiryDays={1}
			useCookiesForTransactions={false}
			useRefreshTokensFallback={true}
			useRefreshTokens={false}
		>
			<BrowserRouter>
				<Routes>
					<Route path={'/'} element={<App />} />
					<Route path={'/usermigration'} element={<UserMigration />} />
				</Routes>
			</BrowserRouter>
		</Auth0Provider>
	</React.StrictMode>
);